import { TimerRefreshIcon } from './TimerRefreshIcon';

/**
 * author: Colton Wiscombe
 * id 131A1665-D2D6-4C5B-B30B-DBDD097EA773
 * name timer-refresh
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/timer-refresh.svg
 * tags
 * - Date / Time 
 */
export const StopwatchRefreshIcon = TimerRefreshIcon;
export default StopwatchRefreshIcon